import { render } from "./ImageSettingsModal.vue?vue&type=template&id=1cbf588e&scoped=true"
import script from "./ImageSettingsModal.vue?vue&type=script&lang=js"
export * from "./ImageSettingsModal.vue?vue&type=script&lang=js"

import "./ImageSettingsModal.vue?vue&type=style&index=0&id=1cbf588e&scoped=true&lang=less"
import "./ImageSettingsModal.vue?vue&type=style&index=1&id=1cbf588e&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cbf588e"]])

export default __exports__